import { Component, OnInit } from '@angular/core';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerPreOrderList',
  templateUrl: './LetterRequestCustomerPreOrderList.component.html',
  styleUrls: ['./LetterRequestCustomerPreOrderList.component.scss']
})
export class LetterRequestCustomerPreOrderListComponent implements OnInit {

  Token:string=""
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:String=''
  EndSearchDate:String=''
  CustomerName:String=''

  BaseUrl = environment.BaseUrl + "Fish/LetterPreOrder?id="

  constructor(
    private login_Service: LoginService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.BaseUrl=environment.BaseUrl + "Fish/LetterPreOrder?token="+ this.Token+"&id="

    this.Nav_Service.CheckValidPage(this.Token,1115).subscribe(
      data=>{
        this.login_Service.GetUserRole(this.Token).subscribe(
          data2=>{
            this.CustomerName=data2['customerName']
          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  GetLetterRequestCustomerPreOrder(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerPreOrder(
      StartSearchDate,
      EndSearchDate,
      this.Token).subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data

        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
